<template>
  <a-card :bordered="false" class="m-t-10">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      创建调仓单
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="调出仓库" name='transfer_warehouse_id'>
        <a-select v-model:value="form.transfer_warehouse_id" style='width: 40%;' @change='outChange' placeholder='请选择调出仓库'>
          <a-select-option v-for='item in outWarehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="调入仓库" name='transfer_to_warehouse_id'>
        <a-select v-model:value="form.transfer_to_warehouse_id" style='width: 40%;' @change='inChange' placeholder='请选择调入仓库'>
          <a-select-option v-for='item in inWarehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="订单备注">
        <a-textarea v-model:value="form.remark" placeholder="请输入订单备注" :rows="4" :maxlength='100' />
      </a-form-item>
      <a-button type="primary" @click='showGood = true'><PlusOutlined />添加商品</a-button>
      <a-table class='m-t-20' :pagination='false' bordered rowKey='product_sn' :columns='columns'  :data-source='goodList'>
        <template v-slot:gift_name="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
            </template>
            <template #description>
              <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:num="{ record }">
          <a-input-number style='width: 100%' v-model:value="record.num" :precision='0' :min='1' placeholder='请输入数量' />
          <p v-if='record.fail' style='color:#ff4d4f'>请输入调仓数量！</p>
        </template>
        <template v-slot:position="{ record }">
          <a-select v-model:value="record.position_id" :placeholder='warehouseChild.length ? "请选择库位":"调入仓库无配置库位"' :disabled="!warehouseChild.length">
            <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.id">{{item.name}}
            </a-select-option>
          </a-select>
        </template>
        <template v-slot:action="{ index }">
          <a-button type="link" @click='delGood(index)'>删除</a-button>
        </template>
      </a-table>
      <div class="m-t-25">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
        <a-button class="width-100" block type="primary" @click="onSubmit">保存</a-button>
      </div>
    </a-form>
  </a-card>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='goodList' :checkout="true" :skuType='true'></selectGood>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { addTransferWarehousing,getWarehouseList } from '@/api/antiFleeing';
  import { iscode } from "@/utils/app";
  import store from "@/store";
  let defForm = {
    transfer_warehouse_id: null,
    transfer_to_warehouse_id:null,
    remark: '',
    product: [],
  };
  export default {
    components: { LeftOutlined,PlusOutlined },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: {span: 3},
        wrapperCol: {span: 12},
        info: store.state.user.info,
        showGood:false,
        goodList: [],
        inWarehouseList:[], // 调入仓库列表
        outWarehouseList:[], // 调出仓库列表
        warehouseChild:[], // 库位列表
        rules: {
          transfer_warehouse_id: [
            { required: true, message: '请选择调出仓库',type:'number'}
          ],
          transfer_to_warehouse_id: [
            { required: true, message: '请选择调入仓库',type:'number'}
          ]
        }
      });
      const columns = [
        {
          title: "商品编码",
          dataIndex: "product_sn",
          key: "product_sn"
        },
        {
          title: "商品信息",
          dataIndex: "gift_name",
          key: "gift_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "调仓数量",
          dataIndex: "num",
          key: "num",
          slots: { customRender: "num" },
        },
        {
          title: "调入库位",
          dataIndex: "position",
          key: "position",
          slots: { customRender: "position" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        }
      ];
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      //选择商品
      const goodSelect = (e) => {
        state.goodList = e
        state.showGood = false
      }
      //删除商品
      const delGood = (index) => {
        state.goodList.splice(index, 1)
      }
      // 调出仓库选择
      const outChange = (e) => {
        if(form.value.transfer_warehouse_id == form.value.transfer_to_warehouse_id){
          $Modal.info({
            centered: true,
            title: '调出仓库和调入仓库需不同仓库，暂不支持同仓库调库位',
            keyboard:false,
            onOk() {
              form.value.transfer_warehouse_id = null
            },
            cancel(){
              form.value.transfer_warehouse_id = null
            }
          })
          return
        }
      }
      // 调入仓库选择
      const inChange = (e) => {
        if(form.value.transfer_to_warehouse_id == form.value.transfer_warehouse_id){
          $Modal.info({
            centered: true,
            title: '调出仓库和调入仓库需不同仓库，暂不支持同仓库调库位',
            keyboard:false,
            onOk() {
              form.value.transfer_to_warehouse_id = null
            },
            cancel(){
              form.value.transfer_to_warehouse_id = null
            }
          })
          return
        }
        if(state.goodList.length){
          state.goodList.map(v=> v.position_id = null)
        }
        var item = state.inWarehouseList.find(v => v.id == e)
        state.warehouseChild = item.child || []
      }
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.inWarehouseList = res.data;
          state.outWarehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      //提交
      const onSubmit = () => {
        form.value.product = []
        state.goodList.forEach(v=>{
          v.fail = false
          if(!isNumber(v.num)){
            v.fail = true
          } 
          form.value.product.push(v.id+'_'+(v.product_sku_sn?v.product_sku_sn:0)+'_'+(v.num?v.num:0)+'_'+v.position_id)
        })
        ruleForm.value.validate().then(() => {
          if(state.goodList.findIndex(v=> v.fail ) !== -1){
            message.error('请输入出库数量!');
            return false
          }
          $Modal.confirm({
            centered: true,
            title: '确认生成调仓单？',
            content: '保存后商品信息将无法修改',
            async onOk() {
              const hide = message.loading("正在加载中...", 0);
              let res = await addTransferWarehousing({ ...form.value}).then((res) => res.data).catch(error => error);
              if (iscode(res)) {
                message.success(res.msg);
                setTimeout(() => {
                  $router.go(-1);
                }, 2000);
              } else {
                message.error(res.msg);
              }
              setTimeout(hide);
            }
          })
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
      onMounted(() => {
        // initData();
        getWarehouse()
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        columns,
        onSubmit,
        goodSelect,
        delGood,
        outChange,
        inChange
      };
    },
  };
</script>